import { apiClient } from "../apiClient";
import { API_ENDPOINTS } from "@repo/constants";
import {
    OneDeskLoginRequest,
    OneDeskLoginResponse,
} from "@repo/types";

export const OneDeskLoginApi = async (
    payload: OneDeskLoginRequest
): Promise<OneDeskLoginResponse> => {
    try {
        const response = await apiClient.post<OneDeskLoginResponse>(
            API_ENDPOINTS.OneDeskLogin,
            payload
        );
        return response.data;
    } catch (error: any) {
        console.error("OneDesk Login Error:", error);
        return {
            Success: false,
            Message: error.response?.data?.Message || "Something went wrong during login",
            StatusCode: error.response?.status || 500,
            Data: [],
        };
    }
};
